import { useState, useEffect, useMemo } from 'react';
import '../styles/Studios.css';
import { useEstudioIndicesForHome } from '../context/HomeConfigContext.jsx';
import img1 from '../images/Estudio/1.jpeg';
import img2 from '../images/Estudio/2.jpeg';
import img3 from '../images/Estudio/3.jpeg';
import img4 from '../images/Estudio/4.jpeg';
import img5 from '../images/Estudio/5.jpeg';
import img6 from '../images/Estudio/6.jpeg';
import img7 from '../images/Estudio/7.jpeg';

const ESTUDIO_IMAGES = [img1, img2, img3, img4, img5, img6, img7];

function pickRandomThree(arr) {
  const shuffled = [...arr].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, 3);
}

function Studios() {
  const indices = useEstudioIndicesForHome();
  const effectivePool = useMemo(() => {
    const pool = indices.map((i) => ESTUDIO_IMAGES[i]).filter(Boolean);
    return pool.length > 0 ? pool : ESTUDIO_IMAGES;
  }, [indices]);
  const [images, setImages] = useState(() => pickRandomThree(ESTUDIO_IMAGES));
  useEffect(() => {
    setImages(pickRandomThree(effectivePool));
  }, [effectivePool]);
  const [lightboxImage, setLightboxImage] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setImages(pickRandomThree(effectivePool));
    }, 4000);
    return () => clearInterval(interval);
  }, [effectivePool]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') setLightboxImage(null);
    };
    if (lightboxImage) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleEscape);
    }
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleEscape);
    };
  }, [lightboxImage]);

  const openLightbox = (src) => setLightboxImage(src);
  const closeLightbox = () => setLightboxImage(null);

  return (
    <section id="instalaciones" className="tm-section tm-studios-section">
      <div className="tm-container">
        <div className="tm-studios-header">
          <div className="tm-studios-header-content">
            <h3 className="tm-studios-subtitle">El Espacio</h3>
            <h2 className="tm-studios-title">
              <span className="tm-studios-title-main">INSTALACIONES</span>
              <span className="tm-studios-title-italic">de lujo en cali</span>
            </h2>
          </div>
          <p className="tm-studios-description">
            Nuestras sedes están ubicadas en sectores estratégicos de la ciudad con fácil acceso a transporte público. Cuentan con espacios amplios, lujosos y modernos, hechos a la medida para una transmisión de la mejor calidad.
          </p>
          <a
            href="https://maps.app.goo.gl/yaqeTMUQsN3QaGXTA?g_st=aw"
            target="_blank"
            rel="noopener noreferrer"
            className="tm-studios-cta"
          >
            ¡Conoce más!
            <span className="material-symbols-outlined tm-studios-cta-icon">arrow_forward</span>
          </a>
        </div>
        <div className="tm-studios-grid">
          <button
            type="button"
            className="tm-studios-main tm-studios-clickable"
            onClick={() => openLightbox(images[0])}
            aria-label="Ver imagen ampliada"
          >
            <img
              src={images[0]}
              alt="Instalaciones TM Studio"
              className="tm-studios-main-img"
              key={images[0]}
            />
            <div className="tm-studios-main-overlay" aria-hidden="true" />
            <div className="tm-studios-main-info">
              <h4 className="tm-studios-main-title">Main Stage</h4>
              <p className="tm-studios-main-tag">Diseño Vanguardista</p>
            </div>
          </button>
          <div className="tm-studios-side">
            <button
              type="button"
              className="tm-studios-card tm-studios-clickable"
              onClick={() => openLightbox(images[1])}
              aria-label="Ver imagen ampliada"
            >
              <img src={images[1]} alt="Estudio TM Studio" className="tm-studios-side-img" key={images[1]} />
              <div className="tm-studios-card-content">
                <span className="material-symbols-outlined tm-studios-card-icon">camera_enhance</span>
                <h5 className="tm-studios-card-title">Tecnología 4K</h5>
              </div>
            </button>
            <button
              type="button"
              className="tm-studios-card tm-studios-clickable"
              onClick={() => openLightbox(images[2])}
              aria-label="Ver imagen ampliada"
            >
              <img src={images[2]} alt="Estudio TM Studio" className="tm-studios-side-img" key={images[2]} />
              <div className="tm-studios-card-content">
                <span className="material-symbols-outlined tm-studios-card-icon">weekend</span>
                <h5 className="tm-studios-card-title">VIP Lounge</h5>
              </div>
            </button>
          </div>
        </div>
      </div>

      {lightboxImage && (
        <div
          className="tm-studios-lightbox-overlay"
          onClick={closeLightbox}
          role="presentation"
        >
          <div
            className="tm-studios-lightbox"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Imagen del estudio"
          >
            <button
              type="button"
              className="tm-studios-lightbox-close"
              onClick={closeLightbox}
              aria-label="Cerrar"
            >
              <span className="material-symbols-outlined">close</span>
            </button>
            <img
              src={lightboxImage}
              alt="Estudio TM Studio"
              className="tm-studios-lightbox-img"
            />
          </div>
        </div>
      )}
    </section>
  );
}

export default Studios;

